import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
interface IProps {
  importedItemsCount: number;
  skippedItemsCount: number;
  rejectionReasons: string[];
  isLastSummaryItem?: boolean;
  isPanelOpen: boolean;
  togglePanel: () => void;
  importedMessage: string;
  skippedMessage: string;
}

export const CollapsibleImportSummary = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <>
      <div>
        {props.importedItemsCount} {props.importedMessage}
        {props.importedItemsCount > 0 && <span className='success'> {t('successfully')}</span>}
        {(!props.isLastSummaryItem || props.skippedItemsCount > 0) && <span>,</span>}
      </div>
      {props.skippedItemsCount > 0 && (
        <div
          className='collapsible'
          onClick={props.togglePanel}
        >
          {props.skippedItemsCount} {props.skippedMessage}
          <span className='fail'> {t('skipped')}</span> <FontAwesomeIcon icon={props.isPanelOpen ? faCaretUp : faCaretDown} />
        </div>
      )}
      {props.isPanelOpen && (
        <div className='collapsible-summary'>
          <ul className='rejection-reasons'>
            {props.rejectionReasons.map((x, index) => (
              <li
                className='rejection-reason'
                key={index}
              >
                {props.rejectionReasons[index]}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
});
